import { Component } from "@angular/core";
import { AppService } from "../app.service";
import { FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Device } from "../device";
import { CryptoService } from "../crypto.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { MatDialog } from "@angular/material/dialog";
import { McpConfigDialogComponent } from "../chat/mcp-config-dialog/mcp-config-dialog.component";

@Component({
  selector: "app-users",
  standalone: false,
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.css"],
})
export class UsersComponent {
  dev: Device | any;
  apiKey: any;
  status: any;
  workspaceName: any;

  displayedColumns: string[] = ["name", "userkey", "action"];
  users: any = [];
  selected = new FormControl("valid", [
    Validators.required,
    Validators.pattern("valid"),
  ]);
  crDate: any;
  showErrorMsg: boolean = false;
  showErrorText: any;

  csummery: any;

  txt: any;
  copiedStates: { [key: string]: boolean } = {};
  loading = true;

  constructor(
    public appService: AppService,
    public router: Router,
    private cs: CryptoService,
    private http: HttpClient,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getConnectorSummary();
    this.loading = true;
    this.getprofiles();
    this.appService.setDefaultVal = this.appService.get(
      "xdbc.workspaceDefault"
    );
  }

  async getConnectorSummary() {

    try {
      let activationPayload: any = {};

      const wsJson = this.appService.get("xdbc.workspace");

      if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
        try {
          const ws = JSON.parse(wsJson);
          this.apiKey = ws.apiKey;
          this.status = ws.status;
        } catch (err) {
          console.error('Invalid JSON:', err);
        }
      }

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);
      const accessToken = this.appService.get("xdbc.accessToken")

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "usage/connector-summary",
        this.apiKey,
        signature,
      );

      if (response && response.status == "Success") {
        this.txt = response.message;
        // this.appService.addSuccessMessage(this.txt);
      }

    } catch (error: any) {
      this.txt = "Activation failed: " + (error.message || "Unknown error");
    }

  }

  formatTimeStamp(ts: number): string {
    const timestamp = ts * 1000;
    const date = new Date(timestamp);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  routeDashboard(uk: any) {
    this.router.navigate(["/user-dashboard/" + uk]);
  }

  routeMemory(uk: any) {
    this.router.navigate(["/memories/" + uk]);
  }

  routeReminder(uk: any) {
    this.router.navigate(["/reminders/" + uk]);
  }

  routeChat(uk: any) {
    this.router.navigate(["/chat/" + uk]);
  }

  async getprofiles() {
    try {
      const wsJson = this.appService.get("xdbc.workspace");

      if (wsJson !== undefined && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
        try {
          const ws = JSON.parse(wsJson);
          this.apiKey = ws.apiKey;
          this.workspaceName = ws.workspaceName;
        } catch (err) {
          console.error('Invalid JSON:', err);
        }
      }

      if (this.status === "ACTIVATED") {
        this.showErrorMsg = false;
      } else {
        this.showErrorMsg = true;
        this.showErrorText =
          "The selected workspace is currently inactive. Please activate it to proceed.";
      }

      const activationPayload = {
        routeType: "UI_SESSION"
      };

      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "auth/list-profile",
        this.apiKey,
        signature,
      );
      this.loading = false;
      if (response && response.status == "Success") {
        this.users = response;
        this.txt = response.message;
        // this.appService.addSuccessMessage(this.txt);
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
      // console.error("Error in submitPrivateKey:", error);
      this.txt = "Activation failed: " + (error.message || "Unknown error");
      // this.appService.addErrorMessage(
      //   "Failed to activate connector: " + (error.message || "Unknown error")
      // );
    }
  }

  maskUserKey(userKey: string): string {
    if (!userKey || userKey.length <= 10) {
      return userKey;
    }
    const start = userKey.substring(0, 3);
    const end = userKey.substring(userKey.length - 4);
    return `${start}${"*".repeat(6)}${end}`;
  }

  getCopyTooltip(userKey: string): string {
    return this.copiedStates[userKey] ? "Copied" : "Copy";
  }

  async copyMessage(message: string) {
    try {
      await navigator.clipboard.writeText(message);

      this.copiedStates[message] = true;

      setTimeout(() => {
        this.copiedStates[message] = false;
      }, 2000);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  openMcpConfigDialog(userKey: string) {
    // Get workspace data for API key
    const wsJson = this.appService.get("xdbc.workspace");
    let apiKey = "";

    if (wsJson && typeof wsJson === 'string' && wsJson.trim() !== '' && wsJson !== 'undefined') {
      try {
        const ws = JSON.parse(wsJson);
        apiKey = ws.apiKey || "";
      } catch (err) {
        console.error('Invalid workspace JSON:', err);
        this.appService.addErrorMessage("Failed to read workspace configuration");
        return;
      }
    }

    // Get base URL from environment
    const baseUrl = environment.baseUrl + "/api";

    const dialogRef = this.dialog.open(McpConfigDialogComponent, {
      width: '500px',
      data: {
        userKey: userKey,
        apiKey: apiKey,
        baseUrl: baseUrl,
        workspaceName: this.workspaceName
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'downloaded') {
        this.appService.addSuccessMessage("MCP configuration downloaded successfully");
      }
    });
  }
}